if (!customElements.get('mobile-accordion')) {
  class MobileAccordion extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.button = this.querySelector('[data-accordion-title]');
      this.content = this.querySelector('[data-accordion-content]');

      if (!this.button || !this.content) return;

      this.height = Number(this.content.scrollHeight);
      this.content.style.setProperty('--height', `${this.height}px`);

      this.button.addEventListener('click', () => {
        this.classList.toggle('is-open');
      });

      if (!this.hasAttribute('data-open')) return;

      this.classList.toggle('is-open');
    }
  }
  customElements.define('mobile-accordion', MobileAccordion);
}
